import contentService from '../services/contentService'

// Dentro de cuántos días (hoy incluido) debe estar la fecha de validación para avisar.
export const DIAS_VALIDACION = 1

/**
 * Posts a los que aún les falta enviar idea creativa / copy / contenido y cuya
 * fecha de validación es hoy, mañana o ya pasó. Los filtra el backend
 * (`/pendientes-envio/`) según el alcance del usuario: Managers ven todos,
 * el resto solo los posts donde es editor.
 */
export async function fetchPendientesEnvio(dias = DIAS_VALIDACION) {
  const { data } = await contentService.getPendientesEnvio(dias)
  return { posts: data.posts || [], alcance: data.alcance || 'mios' }
}

/** Texto y nivel de urgencia según los días que faltan para validar (negativo = atrasada). */
export function urgenciaValidacion(dias) {
  if (dias == null) return { texto: '—', nivel: 'ok', clave: '' }
  if (dias < 0) return { texto: `atrasada ${Math.abs(dias)}d`, nivel: 'late', clave: 'atrasada' }
  if (dias === 0) return { texto: 'hoy', nivel: 'soon', clave: 'hoy' }
  if (dias === 1) return { texto: 'mañana', nivel: 'soon', clave: 'manana' }
  return { texto: `en ${dias}d`, nivel: 'ok', clave: 'otro' }
}
